import React from 'react';
import FormBuilder from './dndForm/formBuilder';
export default function TemplateCreation({currentRecord, saveForm, saveFormData}) {

  return (
    <FormBuilder saveFormData={saveFormData} currentRecord={currentRecord} saveForm={saveForm} />
  );
}
